import { Button } from '@mui/material'
import type { FC } from 'react'
import { Header } from 'src/components/header/Header'
import { HeaderBackButtonMui } from 'src/components/header/HeaderBackButtonMui'
import { HeaderTitle } from 'src/components/header/HeaderTitle'

type Props = {
  onBackButtonClicked: () => void
  onOutputButtonClicked: () => void
  isOutputButtonDisabled?: boolean
}

export const ReportExportDetailHeader: FC<Props> = ({
  onBackButtonClicked,
  onOutputButtonClicked,
  isOutputButtonDisabled = false,
}) => {
  const headerText = '新規でレポート出力'

  return (
    <Header
      aria-label={headerText}
      rightSlot={
        <Button
          onClick={onOutputButtonClicked}
          variant="contained"
          color="primary"
          disabled={isOutputButtonDisabled}
        >
          出力
        </Button>
      }
    >
      <HeaderBackButtonMui onClick={onBackButtonClicked} />
      <HeaderTitle title={headerText} />
    </Header>
  )
}
